<template>
    <div v-show="selected || this.$parent.animated" :class="classes('pane')">
        <slot></slot>
        <div ref="title">
            <slot name="title"></slot>
        </div>
    </div>
</template>
<script>
import { classesMixin } from '../../../common/mixins/classname';
let classMixin = classesMixin('menu-item');
import { FindParentMixin } from '../../../common/mixins/find-parent';
export default {
    mixins: [classMixin, FindParentMixin],
    name: "h-menu-item",

    props: {
        title: String,
        disabled: Boolean,
        data: Object
    },

    data() {
        return {
            inited: false
        };
    },

    computed: {
        index() {
            return this.$parent.tabs.indexOf(this);
        },

        selected() {
            return this.index === this.$parent.curActive;
        }
    },

    watch: {
        'parent.curActive'() {
            this.inited = this.inited || this.selected;
        },

        title() {
            this.$parent.setLine();
        }
    },

    created() {
        this.findParent('van-tabs');
    },

    mounted() {
        const { tabs } = this.$parent;
        const slot = this.$parent.$slots.default;
        const index = slot.indexOf(this.$vnode);
        tabs.splice(index === -1 ? tabs.length : index, 0, this);

        // if (this.slots('title')) {
        //     this.$parent.renderTitle(this.$refs.title, this.index);
        // }
    },

    beforeDestroy() {
        this.$parent.tabs.splice(this.index, 1);
    }
}
</script>
<style lang="less" scoped>
@import './index.less';
</style>
